import {FunctionalModal} from "./FunctionalModal";
import Kanban from "../kanban/Kanban";
import styled from "styled-components";
import {BaseModal} from "./modalStyle";
import React from "react";
import ExitButton from "../buttons/ExitButton";

const KanbanModal = ({setOpen}) => {

    const close = () => {
        setOpen(false)
    }
    const displayModal = () => {
        return (
            <Modal>
                <FirstSection>
                    <h1> Idéation / brainstorming </h1>
                    <ExitButton
                        closeUpdate={close}
                    />
                </FirstSection>
                <Kanban/>
            </Modal>
        )
    }
    return (
        <FunctionalModal component={displayModal()} setOpen={setOpen}/>
    )
}

const Modal = styled(BaseModal)`
    justify-content: space-between;
  height: fit-content;
  position: unset;
  @media (min-width: 1200px) {
    position: absolute;
  }
`

const FirstSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  height: fit-content;
  h1{
    flex-grow: 1;
    margin-left: 2rem;
  }
  .exit-btn{
    align-self: flex-start;
  }
`

export default KanbanModal